import React, { FC, useEffect, useState } from 'react';
import styled, { keyframes } from 'styles/styled-components';
import media from 'utils/mediaStyle';

import { Viewport } from 'components/ViewportProvider';
import { contactUs } from '../../FarmToTablePage/Images';

import { FormattedMessage } from 'react-intl';
import translations from 'translations';
import messages from '../messages';
import ShortContactForm from './ShortContactForm';
import farmToBusinessMessage from '../../FarmToTablePage/messages';

const Container = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0 16px;
  flex-direction: column;
  gap: 24px;
  ${media.lg`
    flex-direction: row;
    padding: 0 10px;
    `}
`;

const SectionContainer = styled.div`
  background: #ffffff;
  ${media.md`
   padding-top: 40px
  `}
`;

const SectionWrapper = styled.div`
  position: relative;
  background-image: url(${contactUs});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
  padding-top: 180%;
  ${media.md`
    padding-top: 80%;
    `}
  ${media.lg`
    padding-top: 40%;
    `}
`;

const TextBox = styled.div``;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${media.md`
    flex-direction: row;
    `}
`;

const Title = styled.span`
  color: #ffffff;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  ${media.md`
    font-size: 40px;
    font-weight: 600;
    line-height: 48px;
    `}
`;

const Description = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: #ffffff;
  margin-top: 6px;
  max-width: 655px;
  ${media.md`
    font-size: 20px;
    line-height: 28px;
    `}
`;

const blink = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
`;

const StyledHeader = styled.span`
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  white-space: nowrap;
  overflow: hidden;
  color: #ffffff;
  white-space: pre-wrap;
  word-break: break-word;
  display: block;
  &::after {
    content: '|';
    margin-left: 2px;
    animation: ${blink} 0.7s step-start infinite;
    color: #ffffff;
  }
  ${media.md`
    font-size: 40px;
    font-weight: 600;
    line-height: 48px;
    display: inline;
    `}
`;

const FormWrapper = styled.div`
  padding: 16px;
  width: 100%;
  background: #ffffff;
  border-radius: 16px;
  max-width: 390px;
  ${media.sm`
    padding: 24px 40px;
    `}
`;

const FormTitle = styled.p`
  display: flex;
  justify-content: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  color: #242527;
  ${media.md`
    font-size: 28px;
    font-weight: 600;
    line-height: 36px;
    `}
`;

const TypingHeader = ({ texts = [''], typingSpeed = 100, pause = 1000 }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [index, setIndex] = useState(0);
  const [textIndex, setTextIndex] = useState(0); // which text in texts[]
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    let timer;
    const currentText: string = texts[textIndex];

    if (!deleting && index < currentText.length) {
      timer = setTimeout(() => {
        setDisplayedText((prev) => prev + currentText[index]);
        setIndex((prev) => prev + 1);
      }, typingSpeed);
    } else if (!deleting && index === currentText.length) {
      timer = setTimeout(() => {
        setDeleting(true);
      }, pause);
    } else if (deleting && index > 0) {
      timer = setTimeout(() => {
        setDisplayedText((prev) => prev.slice(0, -1));
        setIndex((prev) => prev - 1);
      }, typingSpeed / 2);
    } else if (deleting && index === 0) {
      setDeleting(false);
      setTextIndex((prev) => (prev + 1) % texts.length);
    }

    return () => clearTimeout(timer);
  }, [texts, index, deleting, textIndex, typingSpeed, pause]);

  return (
    <div>
      <Title>
        <FormattedMessage {...messages.become} />
        &nbsp;
      </Title>
      <StyledHeader>{displayedText}</StyledHeader>
    </div>
  );
};

const ContactUs: FC = () => {
  return (
    <Viewport.Consumer>
      {({ width }) => {
        return (
          <SectionContainer>
            <SectionWrapper>
              <Container>
                <TextBox>
                  <TitleWrapper>
                    <TypingHeader
                      texts={[
                        translations(farmToBusinessMessage.kamereoCustomer),
                        translations(farmToBusinessMessage.kamereoPartner),
                        translations(farmToBusinessMessage.sustainableBusiness),
                      ]}
                    />
                  </TitleWrapper>
                  <Description>
                    <FormattedMessage {...messages.kamereoCustomerContactDescription} />
                  </Description>
                </TextBox>
                <FormWrapper>
                  <ShortContactForm
                    header={
                      <FormTitle>
                        <FormattedMessage {...messages.contactUs} />
                      </FormTitle>
                    }
                  />
                </FormWrapper>
              </Container>
            </SectionWrapper>
          </SectionContainer>
        );
      }}
    </Viewport.Consumer>
  );
};

export default ContactUs;
